<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="'Conexión Conectia'" [description]="" [awesomeIcon]="'microchip'">
    <ng-container *ngIf="model">
      <div class="row">
        <div class="col-6 mr-auto">
          <div class="col-12">
            <mat-form-field>
              <input matInput type="text" name="Nombre" placeholder="Cliente" [(ngModel)]="model.Nombre" readonly />
            </mat-form-field>
          </div>

          <div class="col-12">
            <div class="row">
              <mat-form-field class="col-6">
                <input matInput type="text" [(ngModel)]="model.IdA3Laboral" name="IdA3Laboral"
                  placeholder="Conectia Id" />
              </mat-form-field>
              <mat-form-field class="col-3">
                <input matInput [type]="typeSecretA3Laboral" [(ngModel)]="model.SecretA3Laboral" name="SecretA3Laboral"
                  placeholder="Secret" (click)="toggleTypeSecretA3Laboral()" />
              </mat-form-field>
              <mat-form-field class="col-3">
                <input matInput [type]="typeOcpApimSubscriptionKey" [(ngModel)]="model.OcpApimSubscriptionKey"
                  name="OcpApimSubscriptionKey" placeholder="Subscription Key"
                  (click)="toggleTypeOcpApimSubscriptionKey()" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <mat-form-field>
                  <input matInput type="password" name="refreshToken" placeholder="Refresh Token"
                    [(ngModel)]="model.RefreshToken" />
                    <button mat-button matSuffix  aria-label="search" (click)="LoginA3Laboral()">
                      <mat-icon>cached</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botonera -->
      <div class="row">
        <div class="col-6 mr-auto">
          <div class="form-group form-button">
            <button class="btn btn-fill btn-success float-right" (click)="save()" >Guardar</button>
            <a class="btn btn-fill btn-danger float-right" routerLink="../">Volver</a>
          </div>
        </div>
      </div>
    </ng-container>
  </app-generic-panel>


</app-generic-container>